var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grafico-content-mobile mt-3"},[_c('b-button',{attrs:{"block":"","variant":"dark"}},[_vm._v(" Gráfico ")]),_c('div',{attrs:{"id":this.plotId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }